import { StepConfig } from '../../../../shared/components/StepperFormModal/types';
import { UserFormStep } from '../../constants';
import UserInfoStep from './UserInfoStep';
import GroupsStep from './GroupsStep';
import SecurityStep from './SecurityStep';
import SummaryStep from './SummaryStep';

// Module level so the component identities are stable; UserFormModal only
// attaches each step's onBeforeLeave. Adding a step is an entry here.
export const USER_FORM_STEPS: readonly StepConfig<UserFormStep>[] = [
  { id: UserFormStep.USER, label: 'User', Component: UserInfoStep, hideBack: true },
  { id: UserFormStep.GROUPS, label: 'Groups', Component: GroupsStep },
  { id: UserFormStep.SECURITY, label: 'Security', Component: SecurityStep },
  { id: UserFormStep.SUMMARY, label: 'Summary', Component: SummaryStep },
];
